import React from 'react';
import { useGetLots } from 'api/lot';
import { GetLotParams, Lot } from 'api/lot/lot.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableLotAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableLotAutocomplete: React.FC<
  EditableLotAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<any, GetLotParams>
    {...props}
    useApiHook={useGetLots}
    getterName='getLots'
    defaultParams={{
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
    }}
    mapOptions={(data: Lot[]) =>
      data.map((lot) => ({
        id: lot.id,
        code: lot.code,
        address: lot.address,
        depotName: lot.depotName,
        enabled: lot.enabled,
      }))
    }
    getOptionLabel={(option) => {
      if (typeof option === 'string') return option;
      return option.code || option.depotName || '';
    }}
    isOptionEqualToValue={(option, selectedValue) => {
      if (!selectedValue || selectedValue === '') return false;
      if (typeof selectedValue === 'string') {
        return (
          option.code === selectedValue || option.depotName === selectedValue
        );
      }
      if (selectedValue?.id === null || selectedValue?.id === undefined) {
        return option.code === selectedValue.code;
      }
      return selectedValue?.id === option?.id;
    }}
    width={undefined}
    disableClearable={disableClearable}
    deduplicateOptions={true}
    deduplicateKey='id'
  />
);
